export default "__VITE_ASSET__BkU0IBDa__"